
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) {
    const productLinks = document.querySelectorAll(".product-item.card a.card__image.product-item__image.product-item__image--has-secondary");

    function hideAllSecondaryImages(exceptContainer = null) {
      productLinks.forEach(function (container) {
        if (container !== exceptContainer) {
          const firstImg = container.querySelector(".product-item__image-figure--primary");
          const secondImg = container.querySelector(".product-item__image-figure--secondary");
          if (firstImg && secondImg) {
            firstImg.style.opacity = "1";
            firstImg.style.visibility = "visible";
            secondImg.style.opacity = "0";
            secondImg.style.visibility = "hidden";
          }
        }
      });
    }

    productLinks.forEach(function (container) {
      container.addEventListener("touchstart", function () {
        // Hide all others first
        hideAllSecondaryImages(container);

        // Show current second image
        const firstImg = container.querySelector(".product-item__image-figure--primary");
        const secondImg = container.querySelector(".product-item__image-figure--secondary");
        if (firstImg && secondImg) {
          firstImg.style.opacity = "0";
          firstImg.style.visibility = "hidden";
          secondImg.style.opacity = "1";
          secondImg.style.visibility = "visible";
        }
      });
    });

    // Hide second image when touching outside any product
    document.addEventListener("touchstart", function (e) {
      const inside = e.target.closest(".product-item.card a.card__image.product-item__image.product-item__image--has-secondary");
      if (!inside) {
        hideAllSecondaryImages();
      }
    });
  }
});



// $(document).ready(function() {
//   if (window.innerWidth <= 768) {
//     var links = $(".product-item.card a.card__image.product-item__image.product-item__image--has-secondary");
 
//     function hideAllSecondaryImages(exceptContainer) {
//       if (exceptContainer === undefined) {
//         exceptContainer = null;
//       }

//       Array.from(links).forEach(function(container) {
//         if (container === exceptContainer) {
//           return;
//         }

//         const firstImg = container.querySelector(".product-item__image-figure--primary");
//         const secondImg = container.querySelector(".product-item__image-figure--secondary");

//         if (firstImg && secondImg) {
//           firstImg.style.opacity = "1";
//           firstImg.style.visibility = "visible";
//           secondImg.style.opacity = "0";
//           secondImg.style.visibility = "hidden";
//         }
//       });
//     }

//     // Initial call to hide all secondary images
//     // hideAllSecondaryImages();

//     // Add touchstart listener to each link
//     links.on("touchstart", function() {
//       hideAllSecondaryImages(this);

//       const firstImg = this.querySelector(".product-item__image-figure--primary");
//       const secondImg = this.querySelector(".product-item__image-figure--secondary");

//       if (firstImg && secondImg) {
//         firstImg.style.opacity = "0";
//         firstImg.style.visibility = "hidden";
//         secondImg.style.opacity = "1";
//         secondImg.style.visibility = "visible";
//       }
//     });
//     $(document).on("touchstart", function (event) {
//       if (!$(event.target).closest("a.card__image.product-item__image--has-secondary").length) {
        
//         hideAllSecondaryImages();
//       }
//     });
//   }
// });














